export default "__VITE_ASSET__BWAsuOJf__"